import styles from "./MissionCreateOrEdit.module.scss";
import moment from "moment/moment";
import React, {useMemo, useState} from "react";
import {DataGrid} from "@mui/x-data-grid";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import TextInput from "../../Components/TextInput/TextInput";
import ImageSubmit from "../../Components/ImageSubmit/ImageSubmit";
import TextAreaInput from "../../Components/TextAreaInput/TextAreaInput";
import {TASK_ACTIONS_LIST, TASK_ITEM_LIST} from "./missionHelper";
import {Checkbox, FormControlLabel, MenuItem, TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import {hasValue} from "../../helpers/helperFunctions";
import { ReactComponent as TrashIcon } from '../../images/svg/trashIcon.svg';

const TasksColums = [
    {field: 'step', headerName: 'step', width: 50},
    {field: 'name', headerName: 'Name', flex: 1},
    {
        field: 'icon',
        headerName: 'Icon',
        width: 100,
        renderCell: (params) => (
            params.value ? <img className={styles.rankImage} src={params.value} alt="profileImage"/> : ''
        )
    },
    {field: 'description', headerName: 'Description', flex: 2},
    {
        field: 'updatedAt',
        headerName: 'Last Updated',
        width: 200,
        renderCell: (params) => (
            moment.unix(params.value).format('YYYY-MM-DD , hh:mm')
        )
    },
];

const TaskAdministrationList = (props) => {
    const {
        taskList,
        setTaskList,
    } = props;

    const [selectedData, setSelectedData] = useState();

    const formatedRows = useMemo(() => {
        if (!taskList) return [];

        return taskList.map((row, index) => {
            return {
                id: index,
                step: index + 1,
                ...row,
            }
        })
    }, [taskList]);

    const updateMissionTask = async () => {
        const index = taskList.findIndex(row => row?.step === selectedData?.step);
        const newList = [...taskList];

        let updatedData = {
            ...selectedData,
        }
        updatedData.updatedAt = moment().unix();

        newList[index] = updatedData;
        setTaskList(newList);
        setSelectedData(undefined);
    }

    const createMissionTask = async () => {
        const newList = [...taskList];
        newList.push({
            name: '',
            description: '',
            icon: '',
            subtasks: [{
                label: '',
                taskItem: '',
                taskAction: '',
                taskValue: '',
                taskExperience: '',
                taskFilterValueStart: '',
                taskFilterValueEnd: '',
                taskItemCollection: '',
            }],
            step: newList.length + 1,
            updatedAt: moment().unix(),
        });
        setTaskList(newList);
        setSelectedData(newList[newList.length - 1]);
    }

    const setSubTaskParamsValue = ({ value, index, key }) => setSelectedData(prev => ({
        ...prev, subtasks: prev.subtasks.map((task, i) => {
            if (i === index) {
                return {...task, [key]: value};
            }
            return task;
        })
    }))

    const renderSubTasks = () => {
        return selectedData?.subtasks.map((subtask, index) => {
            return (<SubTaskRow
                key={index}
                subtask={subtask}
                index={index}
                setSelectedData={setSelectedData}
                setSubTaskParamsValue={setSubTaskParamsValue}
                selectedData={selectedData}
            />);
        })
    }

    return (
        <div className={styles.taskListContainer}>
            <div className={styles.tableContainer}>
                {formatedRows &&
                    <DataGrid
                        rows={formatedRows}
                        onCellDoubleClick={(params) => setSelectedData(params.row)}
                        columns={TasksColums}
                    />}
            </div>
            <div className={styles.buttonContainer}>
                <Button text="Add Task" buttonType={BUTTON_TYPE_SECONDARY} onClick={createMissionTask}/>
            </div>
            {selectedData && <div className={styles.editTaskModalContainer}>
                <div className={styles.taskModalContent}>
                    <h4>Edit Task</h4>
                    <TextInput value={selectedData?.name} label="Name"
                               setValue={(value) => setSelectedData(prev => ({...prev, name: value}))}/>
                    <ImageSubmit base64Value={selectedData?.icon}
                                 setBase64={(value) => setSelectedData(prev => ({...prev, icon: value}))} useBase64
                                 text="Rank Image"/>
                    <TextAreaInput
                        value={selectedData?.description}
                        setValue={(value) => setSelectedData(prev => ({...prev, description: value}))}
                        rows={2} l
                        label="Task Description"/>
                    <div className={styles.taskActionContainer}>
                        {renderSubTasks()}
                        <Button text="Add Subtask" buttonType={BUTTON_TYPE_SECONDARY}
                                onClick={() => setSelectedData(prev => ({
                                    ...prev, subtasks: [...prev.subtasks, {
                                        label: '',
                                        taskItem: '',
                                        taskAction: '',
                                        taskValue: '',
                                        taskExperience: '',
                                    }]
                                }))}/>
                    </div>
                    <div className={styles.buttonContainer}>
                        <Button text="Cancel" onClick={() => setSelectedData(undefined)}
                                buttonType={BUTTON_TYPE_SECONDARY}/>
                        <Button text="Save" buttonType={BUTTON_TYPE_SECONDARY} onClick={updateMissionTask}/>
                    </div>
                </div>
            </div>}
        </div>)
}

export default TaskAdministrationList;

const SubTaskRow = (props) => {
    const {
        subtask,
        index,
        setSelectedData,
        setSubTaskParamsValue,
        selectedData,
    } = props;

    const [timeRangeType, setTimeRangeType] = useState(hasValue(selectedData?.subtasks[index]?.taskFilterDaysIncluded) ? 'range' : 'interval');

    const taskItem = selectedData?.subtasks[index]?.taskItem && TASK_ITEM_LIST.find(item => item.value === selectedData?.subtasks[index]?.taskItem);
    const supportsDateTimeRange = taskItem?.supportsRange;

    return (
        <div key={index} className={styles.subTaskRow}>
            <div className={styles.subTaskItem}>
                <TextInput value={selectedData?.subtasks[index]?.label} label="Task Label"
                           setValue={(value) => setSubTaskParamsValue({value, index, key: 'label'})}/>
            </div>
            <div className={styles.subTaskItem}>
                <TextField
                    id="outlined-select-currency"
                    select
                    defaultValue={selectedData?.subtasks[index]?.taskItem}
                    label="Select"
                    helperText="Select Task Item">
                    {TASK_ITEM_LIST.map((option) => (
                        <MenuItem key={option.value} value={option.value}
                                  onClick={() => setSelectedData(prev => ({
                                      ...prev, subtasks: prev.subtasks.map((task, i) => {
                                          if (i === index) {
                                              return {...task, taskItem: option.value, taskItemCollection: option.collection};
                                          }
                                          return task;
                                      })
                                  }))}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </div>
            {supportsDateTimeRange && <div className={styles.datetimePickerContainer}>
                <div className={styles.checkboxContainer}>
                    <FormControlLabel
                        control={<Checkbox checked={timeRangeType === 'interval'}
                                           onChange={event => setTimeRangeType(event.target.checked ? 'interval' : 'range')}/>}
                        label="Use Date Interval"
                        labelPlacement="top"
                    />
                </div>
                {(timeRangeType === 'range') && <TextInput value={selectedData?.subtasks[index]?.taskFilterDaysIncluded}
                                                         label="Amount of Days to be included"
                                                         placeholder="14 = last 14 days"
                                                         setValue={(value) => setSubTaskParamsValue({
                                                             value,
                                                             index,
                                                             key: 'taskFilterDaysIncluded'
                                                         })}/>}
                {timeRangeType === 'interval' && <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                        value={hasValue(selectedData?.subtasks[index]?.taskFilterValueStart) ? moment.unix(selectedData?.subtasks[index]?.taskFilterValueStart) : null}
                        onChange={(value) => setSubTaskParamsValue({
                            value: hasValue(value) ? moment(value).utc().unix() : value,
                            index,
                            key: 'taskFilterValueStart'
                        })}
                        label="Task Filter Value Start*"/>
                    <DateTimePicker
                        value={hasValue(selectedData?.subtasks[index]?.taskFilterValueEnd) ? moment.unix(selectedData?.subtasks[index]?.taskFilterValueEnd) : null}
                        onChange={(value) => setSubTaskParamsValue({
                            value: hasValue(value) ? moment(value).utc().unix() : value,
                            index,
                            key: 'taskFilterValueEnd'
                        })}
                        label="Task Filter Value End"/>
                </LocalizationProvider>}
            </div>}

            <div className={styles.subTaskItem}>
                <TextField
                    id="outlined-select-currency"
                    select
                    label="Select"
                    defaultValue={selectedData?.subtasks[index]?.taskAction}
                    helperText="Select Task Action">
                    {TASK_ACTIONS_LIST.map((option) => (
                        <MenuItem key={option.value} value={option.value}
                                  onClick={() => setSubTaskParamsValue({value: option.value, index, key: 'taskAction'})}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </div>
            <div className={styles.subTaskItem}>
                <TextInput value={subtask?.taskValue} label="Task Value"
                           setValue={(value) => setSubTaskParamsValue({value, index, key: 'taskValue'})}/>
            </div>

            <div className={styles.subTaskItem}>
                <TextInput value={subtask?.taskExperience} label="Task XP"
                           setValue={(value) => setSubTaskParamsValue({value, index, key: 'taskExperience'})}/>
            </div>
            <div className={styles.trashIconContainer}>
                <TrashIcon className={styles.trashIcon}
                           onClick={() => setSelectedData(prev => ({
                               ...prev, subtasks: prev.subtasks.filter((task, i) => i !== index)
                           }))}/>
            </div>
        </div>
    )
}